// extracted by css-extract-rspack-plugin
export default {"nativeSidebarToggle":"hQxl1","nativeSidebar":"wl3gC"};